// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"u5-z"};